import React, { useEffect, useState } from 'react'
import useBranding from '../useBranding'
import api from '../api'

function rp(n) { return 'Rp ' + Number(n || 0).toLocaleString('id-ID') }
function periodeLabel(periode) {
  const [tahun, bulan] = periode.split('-')
  return new Date(Number(tahun), Number(bulan) - 1, 1).toLocaleDateString('id-ID', { month: 'long', year: 'numeric' })
}

const STATUS_LABEL = { LUNAS: 'LUNAS', SEBAGIAN: 'DIBAYAR SEBAGIAN', BELUM_LUNAS: 'BELUM LUNAS' }

// Markup dokumen invoice/kwitansi -- dipakai DUA tempat (pratinjau modal Tagihan.jsx & halaman cetak
// standalone InvoiceCetak.jsx), reuse class CSS `.slip-doc` dkk yg sama dgn SlipDoc.jsx (nama class
// generik, bukan spesifik payroll -- lihat index.css) supaya tidak perlu tulis CSS cetak baru.
export default function InvoiceDoc({ tagihan }) {
  const businessName = useBranding()
  const [linkTagihan, setLinkTagihan] = useState('')

  // Link tagihan publik (2026-07-22, fase 1 notifikasi isolir) -- ditampilkan di invoice cetak spy
  // pelanggan yg pegang kertasnya bisa cek status tagihan sendiri kapan saja tanpa harus telepon.
  useEffect(() => {
    if (!tagihan.ppp_username) return
    api.get(`/pelanggan-kontak/${encodeURIComponent(tagihan.ppp_username)}/link-tagihan`)
      .then(res => setLinkTagihan(res.data.url))
      .catch(() => {})
  }, [tagihan.ppp_username])

  return (
    <div className="slip-doc">
      <div className="slip-doc-header">
        <div className="company">{businessName.toUpperCase()}</div>
        <div className="doctitle">Tagihan Langganan — Periode {periodeLabel(tagihan.periode)}</div>
      </div>

      <div className="slip-doc-meta">
        <div className="row"><span className="label">Pelanggan</span><span><strong>{tagihan.nama_pelanggan || tagihan.ppp_username}</strong></span></div>
        <div className="row"><span className="label">Username</span><span>{tagihan.ppp_username}</span></div>
        <div className="row"><span className="label">Alamat</span><span>{tagihan.alamat || '-'}</span></div>
        <div className="row"><span className="label">Jatuh Tempo</span><span>{tagihan.jatuh_tempo}</span></div>
      </div>

      <table className="slip-table">
        <thead><tr><th>Rincian</th><th style={{ textAlign: 'right' }}>Jumlah</th></tr></thead>
        <tbody>
          <tr><td>{tagihan.nama_paket}</td><td className="amount">{rp(tagihan.harga_bulanan)}</td></tr>
          {tagihan.diskon > 0 && <tr><td>{tagihan.catatan_diskon || 'Diskon'}</td><td className="amount">−{rp(tagihan.diskon)}</td></tr>}
          {tagihan.biaya_lain > 0 && <tr><td>{tagihan.catatan_biaya_lain || 'Biaya Lain'}</td><td className="amount">{rp(tagihan.biaya_lain)}</td></tr>}
        </tbody>
      </table>

      <div className="slip-total">
        <span>Total Tagihan</span><span>{rp(tagihan.total_tagihan)}</span>
      </div>

      {tagihan.pembayaran && tagihan.pembayaran.length > 0 && (
        <>
          <div className="jurnal-title">Histori Pembayaran</div>
          <table className="jurnal-table">
            <thead><tr><th>Tanggal</th><th>Metode</th><th style={{ textAlign: 'right' }}>Jumlah</th></tr></thead>
            <tbody>
              {tagihan.pembayaran.map(p => (
                <tr key={p.id}>
                  <td className="tgl">{p.tanggal}</td>
                  <td>{p.metode || '-'}{p.keterangan ? ` — ${p.keterangan}` : ''}</td>
                  <td style={{ textAlign: 'right' }}>{rp(p.jumlah)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      <div className="slip-doc-meta" style={{ marginTop: 14 }}>
        <div className="row"><span className="label">Dibayar</span><span>{rp(tagihan.total_dibayar)}</span></div>
        <div className="row"><span className="label">Status</span><span><strong>{STATUS_LABEL[tagihan.status]}</strong></span></div>
      </div>

      <div className="slip-signature">
        <div>
          <div>Mengetahui,</div>
          <div className="line">Admin</div>
        </div>
        <div>
          <div>Diterima oleh,</div>
          <div className="line">{tagihan.nama_pelanggan || tagihan.ppp_username}</div>
        </div>
      </div>

      {linkTagihan && (
        <div style={{ marginTop: 16, fontSize: 11, color: '#666', textAlign: 'center' }}>
          Cek status tagihan kapan saja: {linkTagihan}
        </div>
      )}
    </div>
  )
}
